import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IGroup } from '@/contracts/system-modules/groups/IGroup'
import { ApplyInviteParams } from '@/system-modules/groups/v1/api/v1/groups/ApplyInvite/Dto/ApplyInviteParams'

export class ApplyInviteRoute extends GroupsRoute<ApplyInviteParams, IGroup> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/groups/apply'
  }

  /** Без сервера инвайтов нет: заявку подать нельзя */
  offline(): Promise<ApiResponse<IGroup>> {
    return Promise.resolve(new ApiResponse({ success: false, error: 'invite_not_found' }))
  }
}
